/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { DataTable } from '@scuf/datatable';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Button, Checkbox, Input, Select } from '@scuf/common';
// import './ManageTariffTheme.scss';
// import MangeTariffTOU from './MangeTariffTOU';

const ManageTariffParent = (props: IAny) => {
  const [checkedObj, setCheckedObj] = useState<IAny>(props.checkedDaysOfWeek);
  const [atleastOneChecked, setAtleastOneChecked] = useState<boolean>(false);

  const changeValue = (checked: boolean, key: string) => {
    const tempCheckedObj = { ...checkedObj };
    tempCheckedObj[key] = checked;
    props.setCheckedDaysOfWeek(tempCheckedObj);
  };

  useEffect(() => {
    setAtleastOneChecked(
      Object.keys(checkedObj).some((dy: string) => checkedObj[dy])
    );
  }, [checkedObj]);

  useEffect(() => {
    setCheckedObj(props.checkedDaysOfWeek);
  }, [props.checkedDaysOfWeek]);
  return (
    <div
      style={props.isNewBill ? { top: '477.5px' } : { top: '435.5px' }}
      className="Days-Of-Week"
    >
      <div className="Checkbox">
        {[
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ].map((dy) => {
          return [
            <Checkbox
              checked={checkedObj[dy]}
              label={dy}
              onChange={(checked: boolean) => {
                changeValue(checked, dy);
              }}
            />
            // ,
            // <hr className='Time-Of-Range-HR'/>
          ];
        })}
        <div style={{ width: '50%' }}>
          <Button
            disabled={!atleastOneChecked}
            className="Days-Of-Week-Button"
            onClick={() => props.onDaysDone()}
            type="primary"
            content="Done"
          />
        </div>
      </div>
    </div>
  );
};

export default ManageTariffParent;
